<div class="dm-cart-data-servico">
  <div class="dm-cart-data-servico-content">
    <div #datepicker class="datepicker-inline"></div>
  </div>   
  <loader classCustom="absolute" *ngIf="loader"></loader>   
</div>

